module.exports = __webpack_public_path__ + "public/images/prizes/prize-5.654119dd1f02d755280c400217c39afb.jpg";